class SubcollectionSlider extends window.BAO.CustomElement() {
  constructor() {
    super()
  }

  connectedCallback() {
    super.connectedCallback()

    this.setupSlider()
  }

  setupListeners () {
    super.setupListeners()

    this.handleResize = this.handleResize.bind(this)
    window.addEventListener('resize', this.handleResize)
  }

  handleResize () {
    this.setupSlider()
  }

  setupSlider () {
    this.keenSliderInstance = new KeenSlider(this.els.slider.element,
      {
        selector: this.els.slide.selector,
        loop: false,
        rubberband: false,
        mode: 'snap',
        slides: {
          perView: 'auto',
          spacing: 8,
        },
      },
      [
        window.BAO.Carousel.plugins.useInitialised(),
        window.BAO.Carousel.plugins.useArrows({
          next: this.els.next.element,
          previous: this.els.prev.element
        }),
      ],
    )
  }
}

if(!customElements.get('subcollection-slider')) {
  customElements.define('subcollection-slider', SubcollectionSlider)
}